import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "color", "borderWidth", "backgroundColor", "legacy", "size"];
import styled from 'styled-components';
import { IconCircle as IconCircleFoundations } from 'foundations-components/transitional/components/IconCircle';
import { cloneChildren } from '../cloneChildren';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const BASE_ICON_SIZE = 8;
const BASE_FONT_SIZE = 14;
const backgroundColorMap = {
  brand: 'icon-core-subtle',
  danger: 'fill-accent-red-default',
  disabled: 'border-core-pressed',
  info: 'fill-accent-blue-default',
  inverse: 'fill-surface-default',
  light: 'border-core-subtle',
  onboarding: 'fill-accent-purple-default',
  success: 'fill-accent-green-default',
  warning: 'fill-accent-yellow-default'
};
const colorMap = {
  white: 'fill-surface-default',
  default: 'text-core-default'
};
const iconSizeMap = {
  default: `${BASE_ICON_SIZE / BASE_FONT_SIZE}em`,
  xxxs: '8px',
  xxs: '12px',
  xs: '14px',
  sm: '16px',
  md: '20px',
  lg: '24px',
  xl: '28px',
  xxl: '32px',
  xxxl: '48px',
  xxxxl: '64px',
  xxxxxl: '80px',
  xxxxxxl: '96px',
  '2xl': '32px',
  '3xl': '48px',
  '4xl': '64px',
  '5xl': '80px',
  '6xl': '96px'
};
const Wrapper = styled(LayoutBox).withConfig({
  displayName: "IconCircle__Wrapper",
  componentId: "sc-1d92idh-0"
})(["font-size:", ";"], ({
  $size
}) => $size);
export const IconCircle = _ref => {
  let {
      children,
      color = 'default',
      borderWidth = '0',
      backgroundColor,
      legacy = true,
      size = 'sm'
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const Icon = props => cloneChildren({
    children,
    newProps: props
  });
  return /*#__PURE__*/_jsx(Wrapper, {
    $size: iconSizeMap[size],
    children: /*#__PURE__*/_jsx(IconCircleFoundations, Object.assign({}, rest, spacingProps, {
      backgroundColor: backgroundColorMap[backgroundColor || 'light'],
      borderWidth: borderWidth,
      color: colorMap[color],
      icon: Icon,
      legacy: legacy
    }))
  });
};